<div class="record-actions"></div>
@if (showGroup()) {
  <div class="header-group-dropdown"></div>
}
@if (confidentialityTmpl()) {
  <div class="record-confidentiality">
    <span class="header confidentiality">
      {{ 'template.reportViewState' | translate | uppercase }}
    </span>
  </div>
}
<div class="header-cell">
  @for (field of allFields(); track field; let index = $index) {
    <div>
      <span class="compare-cell header-cell name">{{ field.label }}</span>
    </div>
  }
</div>
